import { render, staticRenderFns } from "./createDrawer.vue?vue&type=template&id=767d47e5&scoped=true&"
import script from "./createDrawer.vue?vue&type=script&lang=ts&"
export * from "./createDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./createDrawer.vue?vue&type=style&index=0&id=767d47e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767d47e5",
  null
  
)

export default component.exports